// extracted by mini-css-extract-plugin
export default {"cvError":"t1-z"};